<div class="address-header">
  <h4 class="bold accent mb-0">
    {{
      projectPlacement.address?.line1
        | printAddress
          : projectPlacement.address?.postalCode
          : projectPlacement.address?.city
    }}
  </h4>
  <mat-icon
    *ngIf="installerView"
    (click)="hideAddressFields = !hideAddressFields"
    class="edit-icon"
    matTooltip="Bewerk adres"
  >
    edit
  </mat-icon>
</div>

<div *ngIf="!hideAddressFields">
  <div class="mt-3">
    <map
      [showMap]="false"
      [inputAddress]="editableAddress"
      [fromOldSystem]="fromOldSystem"
      [installerView]="installerView"
      (outputAddress)="editableAddress = $event"
    ></map>

    <div class="btn-container">
      <button
        *ngIf="!saving"
        class="btn btn-cancel mr-2"
        mat-flat-button
        (click)="cancel()"
      >
        Cancel
      </button>

      <button
        *ngIf="!saving"
        class="btn btn-save mr-2"
        mat-flat-button
        (click)="save()"
      >
        Opslaan
      </button>

      <mat-spinner *ngIf="saving" color="primary" diameter="20"></mat-spinner>
    </div>

    <hr />

    <br />
  </div>
</div>

<div [class.disable]="!hideAddressFields">
  <p
    *ngIf="
      projectPlacement.placementFloor != null &&
      projectPlacement.placementFloor.trim() != ''
    "
    class="mb-3"
  >
    Verdiep:
    <b>{{ projectPlacement.placementFloor }}</b>
  </p>

  <p
    *ngIf="projectPlacement.extraPlacementInfo?.length > 0"
    class="bold font-16 preserve-line-break"
  >
    {{ projectPlacement.extraPlacementInfo }}
  </p>

  <ng-container *ngIf="!fromOldSystem && !installerView">
    <div class="appointment-info-container mb-3">
      <placement-card-appointment-info
        *ngIf="projectPlacement.appointment || projectPlacement.collectKey"
        [projectPlacement]="projectPlacement"
        [project]="project"
        [subProject]="subProject"
      ></placement-card-appointment-info>
    </div>
  </ng-container>

  <div class="mb-3">
    <placement-card-ip-board-extras-info
      *ngIf="ipBoard != null"
      [ipBoard]="ipBoard"
      [projectPlacement]="projectPlacement"
      [installerView]="installerView"
    ></placement-card-ip-board-extras-info>
  </div>

  <ng-container
    *ngIf="
      notExecutedHistoryItem && notExecutedHistoryItem.stockAtBranch && !client
    "
  >
    <div class="delayed-item-container mb-3">
      <strong
        >Uitgesteld bord te: {{ notExecutedHistoryItem.stockAtBranch?.name }}
      </strong>
      <br />
      {{ notExecutedHistoryItem.author?.firstName }}
      {{ notExecutedHistoryItem.author?.lastName }} -
      {{ notExecutedHistoryItem.createdTimestamp | date : 'dd/MM/yyyy' }}
    </div>
  </ng-container>

  <p *ngIf="ipBoard?.boardPart?.sign?.poleColor?.label" class="mb-0 mt-0">
    Kleur hout: <b>{{ ipBoard.boardPart?.sign.poleColor.label }}</b>
  </p>

  <p
    *ngIf="
      ipBoard?.boardPart?.sign?.poleColor?.label == null &&
      ipBoard?.poleColor?.label
    "
    class="mb-0 mt-0"
  >
    Kleur hout:
    <b>{{ ipBoard.poleColor?.label }}</b>
  </p>

  <ng-container *ngIf="!fromOldSystem">
    <div
      [class.mt-0]="
        !!ipBoard?.boardPart?.sign?.poleColor?.label ||
        !!ipBoard?.poleColor?.label
      "
    >
      <p class="mb-0">
        Gewenste plaatsingdatum:
        <b>
          <ng-container *ngIf="projectPlacement.placeASAP; else date">
            A.S.A.P.
          </ng-container>

          <ng-template #date>
            <span class="accent">
              {{ projectPlacement.placementEarliestDate | date : 'dd/MM/yyyy' }}
            </span>
          </ng-template>
        </b>
      </p>
    </div>
  </ng-container>

  <div *ngIf="isAdmin && addressPanoId" class="streetview-button-container">
    <a
      href="{{ addressPanoId | googleStreetviewLink }}"
      target="_blank"
      class="street-view-button"
      >Streetview</a
    >
  </div>
</div>
